import { Form, Typography } from "antd";
import AppContent from "common/AppContent";
import AppPageHeader from "common/PageHeader";
import ExtraContent from "components/Configuration/CommonComponents/ExtraContent";
import { NO_PERMISSION_REQUIRED } from "routes/permissions";
import { hasPermission } from "utils/functions";
import InvoiceForm from "../InvoiceForm";
// Antd Constants
const { Title } = Typography;
export default function ExportInvoiceExpenseUpdate() {
  const [form] = Form.useForm();

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <ExtraContent
                hideFilterButton
                addButtonText={
                  hasPermission([NO_PERMISSION_REQUIRED])
                    ? "Update"
                    : "No Permission"
                }
                handleAddItemOpen={() => form.submit()}
                showBackButton
              />
            }
            title={<Title level={5}>Export Invoice Expense Update</Title>}
          />
        }
        content={
          <>
            <InvoiceForm form={form} mode="update" />
          </>
        }
      />
    </>
  );
}
